import React from 'react'

export default function Auratower() {

    // Additional images for Variant Apartment Building
    const additionalImages = [

        "/images/mainaura.jpeg",
        "/images/aura2.jpeg",
        "/images/aura11.jpeg",
        "/images/aura9.jpeg",
        "/images/aura10.jpeg",
        "/images/aura13.jpeg",

        "/images/aura3.jpeg",
        "/images/aura4.jpeg",
        "/images/aura5.jpeg",
    ];
    return (
        <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
            {/* Top Section: Text and Main Image */}
            <div className="flex flex-col lg:flex-row items-start gap-8">
                {/* Left Text Section */}
                <div className="lg:w-2/3 space-y-6">
                    <h2 className="text-3xl font-bold text-gray-800">
                        Aura Tower 3G Gulberg 2 Lahore
                    </h2>
                    <h3 className="text-2xl font-bold text-gray-800 leading-tight">
                        Construction Services by PACIFIC BUILDERS (PVT) LTD
                    </h3>
                    <p className="text-gray-700">
  Aura Tower is a modern high-rise residential project situated in the prime location of Gulberg 2, Lahore.
  <strong> PACIFIC BUILDERS (PVT) LTD</strong> has been entrusted with the civil and grey structure works, delivering excellence through superior construction quality, engineering precision, and commitment to structural safety.
</p>
                    {/* <p className="text-gray-700">
                        The Aura Tower is a high-rise residential project in the heart of Gulberg 2, Lahore.
                        <strong> PACIFIC BUILDERS (PVT) LTD</strong> is proud to be delivering precision-driven construction with the utmost quality and structural integrity for this modern development.
                    </p> */}

                    <div className="text-lg text-gray-700">
                        <p><strong>Scope of Work:</strong> Civil and Grey Structual Works</p>
                                    <p><strong>Architect:</strong> Aeternum PVT LTD</p>
                                    <p><strong>Project Description:</strong> Apartment Building </p>
                                    <p><strong>Project Cost:</strong> 230 Million</p>
                                    <p><strong>Client:</strong> Aeternum PVT LTD</p>
                                    <p><strong>Status:</strong> Ongoing</p>
                    </div>
                </div>

                {/* Right Image Section */}
                <div className="lg:w-1/3">
                    <img
                        src="/images/aura1.jpeg"
                        alt="Aura Tower Construction"
                        className="w-full h-auto rounded shadow"
                    />
                </div>
            </div>

            {/* Additional Images Section */}
            {additionalImages.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {additionalImages.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt={`Variant Apartment ${index + 1}`}
                            className="w-full h-[250px] rounded shadow"
                        />
                    ))}
                </div>
            )}
        </div>

    )
}
